import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChatUIState {
    open: boolean;
    chatId?: string;
    chatData?: any;
    action?: any;
}

const initialState: ChatUIState = {
    open: false,
    chatId: undefined,
    chatData: undefined,
    action: undefined,
};

export const chatsUISlice = createSlice({
    name: 'chatsUI',
    initialState,
    reducers: {
        openChat(state, action: PayloadAction<{ chatId?: string; data?: any; action?: any }>) {
            state.open = true;
            state.chatId = action.payload.chatId;
            state.chatData = action.payload.data;
            state.action = action.payload.action;
        },
        closeChat(state) {
            state.open = false;
            state.chatId = undefined;
            state.chatData = undefined;
            state.action = undefined;
        },
    },
});
export const { openChat, closeChat } = chatsUISlice.actions;

export default chatsUISlice.reducer;